export default {"src":"/_next/static/media/complete-your-profile.87f649d5.svg","height":270,"width":395,"blurWidth":0,"blurHeight":0};